"use strict";
/**
 * EpicService.ts
 * Real Epic Games OAuth 2.0 Integration for Meci.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.epicService = void 0;
class EpicService {
    constructor() {
        this.listeners = new Set();
        if (typeof window !== 'undefined') {
            this.setupOAuthListeners();
        }
    }
    setupOAuthListeners() {
        window.addEventListener('message', (event) => {
            if (event.data?.type === 'MECI_EPIC_CONNECTED') {
                const data = event.data;
                if (data.displayName) {
                    localStorage.setItem('meci_conn_epic', data.displayName);
                    if (data.epicId)
                        localStorage.setItem('meci_epic_id', data.epicId);
                    if (localStorage.getItem('meci_conn_epic_show') === null) {
                        localStorage.setItem('meci_conn_epic_show', 'true');
                    }
                    this.notify();
                }
            }
        });
    }
    /**
     * Open Epic Games OAuth 2.0 login popup
     */
    loginWithEpic() {
        const authUrl = 'https://meci.teymensel.com/oauth/epic';
        const width = 600;
        const height = 750;
        const left = Math.max(0, (window.innerWidth - width) / 2 + window.screenX);
        const top = Math.max(0, (window.innerHeight - height) / 2 + window.screenY);
        const popup = window.open(authUrl, 'meci_epic_auth', `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`);
        if (popup) {
            popup.focus();
        }
        else {
            window.location.href = authUrl;
        }
    }
    connectManual(displayName, epicId = '') {
        const name = displayName.trim();
        if (!name)
            return;
        localStorage.setItem('meci_conn_epic', name);
        if (epicId) {
            localStorage.setItem('meci_epic_id', epicId);
        }
        else if (!localStorage.getItem('meci_epic_id')) {
            localStorage.setItem('meci_epic_id', 'epic_' + Math.random().toString(36).substring(2, 9));
        }
        if (localStorage.getItem('meci_conn_epic_show') === null) {
            localStorage.setItem('meci_conn_epic_show', 'true');
        }
        this.notify();
    }
    isLoggedIn() {
        return !!(localStorage.getItem('meci_conn_epic') || localStorage.getItem('meci_epic_id'));
    }
    getProfile() {
        const displayName = localStorage.getItem('meci_conn_epic');
        const epicId = localStorage.getItem('meci_epic_id');
        if (!displayName && !epicId)
            return null;
        return {
            displayName: displayName || 'Epic Oyuncusu',
            epicId: epicId || ''
        };
    }
    isShowOnProfile() {
        return localStorage.getItem('meci_conn_epic_show') !== 'false';
    }
    setShowOnProfile(val) {
        localStorage.setItem('meci_conn_epic_show', String(val));
        this.notify();
    }
    disconnect() {
        localStorage.removeItem('meci_conn_epic');
        localStorage.removeItem('meci_epic_id');
        this.notify();
    }
    subscribe(listener) {
        this.listeners.add(listener);
        return () => {
            this.listeners.delete(listener);
        };
    }
    notify() {
        this.listeners.forEach(l => {
            try {
                l();
            }
            catch (e) {
                console.error(e);
            }
        });
    }
}
exports.epicService = new EpicService();
